import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import FetchApi from '../../customhooks/functionFetchApi_erp';
import { FaSearch } from "react-icons/fa";
import DataTable from 'react-data-table-component';


function TableItemList({ data, hendleModel, selectRefFf ,}) {


    const selectItem = (itemid, itemnames) => {
        selectRefFf(itemid)

        hendleModel(false)
    }

    const columns = [
        {
            name: 'Item ID',
            sortable: true,
            selector: row => row.itemid,
        },
        {
            name: 'Item Name',
            grow: 2,
            selector: row => row.Itemname,
        },
        {
            name: 'เลือกกุล่ม',
            selector: row => <div>
                <Button variant="primary" size='sm' onClick={() => selectItem(row.itemid, row.Itemname)}>เลือกกลุ่ม</Button>

            </div>,
        },
    ];

    const customStyles = {
        headRow: {
            style: {
                border: 'none',
                backgroundColor: '#28B463'
            },
        },
        headCells: {
            style: {
                color: '#ffff',
                fontSize: '14px',
            },
        },
        // rows: {
        //     highlightOnHoverStyle: {
        //         backgroundColor: 'rgb(230, 244, 244)',
        //         borderBottomColor: '#FFFFFF',
        //         borderRadius: '25px',
        //         outline: '1px solid #FFFFFF',
        //     },
        // },
        // pagination: {
        //     style: {
        //         border: 'none',
        //     },
        // },
    };

    return (
        <DataTable
            columns={columns}
            data={data}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )

}



function PopupRefFG(props) {

    const FetchApis = new FetchApi();
    const [show, setShow] = useState(false);
   
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [itemList, setItemList] = useState([]);
    const [textSearch, setTextSearch] = useState([]);

    useEffect(() => {

        getapilist()

    }, [])

    const hendleModel = (value) => {
        setShow(false)
    }

    const getapilist = () => {
        
        FetchApis.FethcGet(`getItemFG`).then((res) => {
            if (res.status == 200) {
               
                setItemList(res.data.listall)
                setTextSearch(res.data.listall);
            }
        })
    }

    const onSearchText = (datavalue) => {

        const filteredData = textSearch.filter((item) => {
            return Object.values(item).join('').toLowerCase().includes(datavalue.toLowerCase())
          })

          setItemList(filteredData)
    }

    return (
        <div>
            
            <FaSearch variant="primary" onClick={handleShow} size={20}>
                Launch demo modal
            </FaSearch>

            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Item list</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="ค้นหา ป้อนข้อมูล" size='sm' onChange={(e) => onSearchText(e.target.value)} />
                        </Form.Group>
                    </Form>

                    {
                        itemList.length > 0 && <TableItemList data={itemList} hendleModel={hendleModel} 
                        selectRefFf={props.selectRefFf} 
                        ComponentSelectRefFf={props.ComponentSelectRefFf}/>
                    }

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default PopupRefFG